






























































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class AxCardField extends Vue {
  @Prop({ type: Boolean, default: false })
  full!: boolean;

  @Prop({ type: String, default: '' })
  label!: string;

  @Prop({ type: String, default: '50' })
  labelWidth!: string;

  @Prop({ type: String, default: '' })
  basis!: string;

  // @Prop({ type: Number, default: 15 })
  // fontSize!: number;

  get basisVal() {
    const flexBasis = this.full ? '100%' : this.basis;
    if (flexBasis) {
      return `flex-basis: ${flexBasis};`;
    }
    return '';
  }
}
